<template>
  <div class="swiper-container">
    <swiper
    :spaceBetween="30"
    :centeredSlides="true"
    :autoplay="{
      delay: 2500,
      disableOnInteraction: false,
    }"
    :pagination="{
      clickable: true,
    }"
    :modules="modules"
    class="mySwiper"
  >
    <swiper-slide v-for="(img, index) in $store.getters['media/getTopColumnSlider']" :key="index">
      <img @contextmenu.prevent :src="imageSrc(img.path)">
    </swiper-slide>
  </swiper>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'swiper/vue'
import 'swiper/css'
import 'swiper/css/pagination'
import { Autoplay, Pagination } from 'swiper/modules'

export default {
  components: {
    Swiper,
    SwiperSlide
  },
  data () {
    return {
      cacheBuster: Date.now()
    }
  },
  setup () {
    return {
      modules: [Autoplay, Pagination]
    }
  },
  methods: {
    imageSrc (src) {
      return `${src}?t=${this.cacheBuster}`
    }
  }
}
</script>

<style scoped>
  .swiper {
  width: 100%;
  height: 190px;
}

.swiper-container {
  width: 100%;
  height: 188px;
  margin-bottom: 80px;
}

.swiper-slide img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
  }
</style>
